import { getReadyServiceWorker } from "./serviceWorkerHelper";

const NotificationData = {
  title: "Would you like to receive Push Notifications?",
  description:
    "We promise to only send you relevant content and give you updates on your transactions",
  primaryText: "Sign me up!",
  secondaryText: "No thanks",
};

export async function getCurrentPushSubscription() {
  try {
    const sw = await getReadyServiceWorker();
    return sw?.pushManager?.getSubscription?.();
  } catch (e) {
    console.log('catch error: getCurrentPushSubscription', e?.message);
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerPushNotifications() {
  // requestPermission();
  try {
    console.log("registerPushNotifications", typeof window);

    if (typeof window !== "undefined") {
      if (!("PushManager" in window)) {
        console.info("Push Notification are not supported by this browser");
      }

      const existingSubscription = await getCurrentPushSubscription();
      console.log(
        "existingSubscription",
        existingSubscription,
        process.env?.REACT_APP_NOTIFICATION_APPLICATION_SERVER_KEY
      );

      if (existingSubscription) {
        console.info("Existing Push Notification found");
        return;
      }

      const sw = await getReadyServiceWorker();
      const serviceWorker = sw?.installing || sw?.waiting || sw?.active;

      if (serviceWorker) {
        const subscription = await sw?.pushManager?.subscribe?.({
          userVisibleOnly: true,
          applicationServerKey:
            urlBase64ToUint8Array(process.env?.REACT_APP_NOTIFICATION_APPLICATION_SERVER_KEY) ||
            // "BGJ8rHKR3cHDcLsjeljR2obI7R2yblAZ5G4UMXsid6M0BJwZATPeZzBlh8R4XdQGdV0Offxpw-cp2168s0UwIwI", // UAT
            urlBase64ToUint8Array("BJL4Y3clGpDvTYHDGTL07u83lmYYjsdUIjBESH1fE316bQauZhbYfM7T9PNFZTLiYFFbbrRY6Mtz7N4AUPGFvKw"), // LIVE
        });

        await sendPushSubscriptionToServer(subscription);
      }
    }
  } catch (e) {
    console.log('catch error: register push notification', e?.message);
  }
}

export async function unregisterPushNotification() {
  try {
    const existingSubscription = await getCurrentPushSubscription();

    if (!existingSubscription) {
      console.info("No existing push notification found");
    }

    await deletePushSubscriptionFromServer(existingSubscription);

    await existingSubscription?.unsubscribe?.();
  } catch (e) {
    console.log('catch error: unregister push notification', e?.message);
  }
}

export async function sendPushSubscriptionToServer(subscription) {
  try {
    console.log("Sending push subscription to server", subscription);
    setTimeout(async () => {
      await pushNotificationAlert(NotificationData);
    }, 2000);
  } catch (e) {
    console.log('catch error: sendPushSubscriptionToServer', e?.message);
  }
}

export async function deletePushSubscriptionFromServer(subscription) {
  console.log("Deleting push subscription from server", subscription);
}

export const pushNotificationAlert = async ({
  title,
  description,
  primaryText,
  secondaryText,
}) => {
  console.log("pushNotificationAlert Push subscription");
  try {
    if (typeof window !== "undefined") {
      // const clevertap = window?.clevertap;
      // console.log("clevertap>>>", clevertap);
      // if (clevertap) {
      //   clevertap?.notifications?.push?.({
      //     // "apnsWebPushId":"<apple web push id>", //only for safari browser
      //     // "apnsWebPushServiceUrl":"<safari package service url>",//only for safari browser
      //     titleText: title || "Would you like to receive Push Notifications?",
      //     bodyText:
      //       description ||
      //       "We promise to only send you relevant content and give you updates on your transactions",
      //     okButtonText: primaryText || "Sign me up!",
      //     rejectButtonText: secondaryText || "No thanks",
      //     okButtonColor: "#f28046",
      //   });
      //   // console.log("clevertap", clevertap);
      //   // clevertap.privacy.push({ optOut: true });
      //   // clevertap.privacy.push({ useIP: true });
      // }
    }
  } catch (error) {
    console.log("pushNotificationAlert error:", error);
  }
};

//For Safari
// function requestPermission() {
//     if ('safari' in window && 'pushNotification' in window.safari) {

//         window.safari.pushNotification.requestPermission(
//             'https://localhost:3000/',
//             'https://mf.moamc.com/', {}, function(subscription) {
//                 console.log(subscription);
//                 if(subscription.permission === 'granted') {
//                     let subscriptionInfoSafari = subscription;
//                    let safariToken = subscription.deviceToken;
//                     // sending(safariToken);
//                     // updateSubscriptionOnServer(subscription);
//                 }
//                 else if(subscription.permission === 'denied') {
//                     // TODO:
//                 }
//             });

//     } else {
//         alert("Push notifications not supported.");
//     }
// }
